import { useEffect } from "react";
import { useSite, maybeRedirectToLang } from "@/lib/site";
import DemoLanding from "./DemoLanding";

const detectMktLang = () => {
  try {
    const q = new URLSearchParams(window.location.search).get("lang");
    if (q === "en" || localStorage.getItem("mkt_lang_choice") === "en") return "en";
    if (["es", "pt", "fr"].includes(q)) return q;
  } catch (e) { /* noop */ }
  const n = (navigator.language || "en").slice(0, 2).toLowerCase();
  return ["es", "pt", "fr"].includes(n) ? n : "en";
};

export default function DistributorLanding() {
  const lang = detectMktLang();
  const { g, brand, seo, loaded } = useSite("distributor", lang);
  useEffect(() => { maybeRedirectToLang("/become-a-distributor", "become-a-distributor/"); }, []);
  useEffect(() => {
    if (seo?.meta_title) document.title = seo.meta_title;
    window.scrollTo(0, 0);
  }, [seo]);
  return (
    <DemoLanding
      cms={loaded ? { __g: true } : null}
      brandOverride={brand?.app_name || null}
      testId="distributor-landing-page"
      gOverride={g}
    />
  );
}
